import type { Dict } from './en.js';

// Español
export const es: Dict = {
  loading: 'Cargando…',
  back: '← Volver',
  logOut: 'Cerrar sesión',
  language: 'Idioma',

  home_tagline: 'Fotos del evento + desafíos. Escaneá un QR para unirte, o organizá tu fiesta.',
  home_joinEvent: 'Unirse a un evento',
  home_joinPlaceholder: 'Ingresá el código (ej. WS2X9Z)',
  home_join: 'UNIRSE',
  home_hosting: '¿Organizás?',
  home_openConsole: 'ABRIR CONSOLA DE ANFITRIÓN →',
  how_eyebrow: 'Cómo funciona',
  how_scan_label: 'Escaneá',
  how_scan_desc: 'Apuntá tu cámara al QR de la fiesta',
  how_shoot_label: 'Sacá',
  how_shoot_desc: 'Sumá tus mejores fotos a la galería',
  how_vote_label: 'Votá',
  how_vote_desc: 'Coroná a los ganadores de cada desafío',

  growth_pitch: '¿Querés desafíos así en tu fiesta?',
  growth_cta: 'Creá la tuya →',
  support_contact: 'Soporte',

  // marketing landing (public root "/")
  mkt_nav_cta: 'Creá tu evento',
  mkt_nav_docs: 'Cómo funciona',
  mkt_hero_eyebrow: 'El juego de fotos para tu fiesta',
  mkt_hero_title: 'Convertí tu fiesta en un <em>desafío de fotos</em>.',
  mkt_hero_sub:
    'Los invitados escanean un código QR, suman sus mejores fotos a una galería en vivo y votan en desafíos divertidos. Los ganadores se revelan al final de la noche — sin ninguna app para instalar.',
  mkt_hero_ctaPrimary: 'Creá tu evento',
  mkt_hero_ctaSecondary: 'Ver cómo funciona',
  mkt_hero_trust: 'Sin app para invitados · Funciona en cualquier teléfono · Listo en minutos',
  mkt_wall_winner: 'Ganador',
  mkt_how_eyebrow: 'Cómo funciona',
  mkt_how_title: 'Tres toques. Sin descargas.',
  mkt_feat_eyebrow: 'Qué incluye',
  mkt_feat_title: 'Todo lo que tu fiesta necesita para jugar.',
  mkt_feat_gallery_title: 'Galería de fotos en vivo',
  mkt_feat_gallery_desc: 'Las fotos de todos los invitados llegan a un mismo muro en tiempo real.',
  mkt_feat_challenges_title: 'Desafíos de fotos y votación',
  mkt_feat_challenges_desc: 'Mejor vestido, mejor paso de baile, cara más graciosa — los invitados votan a los ganadores.',
  mkt_feat_reveal_title: 'Revelación de ganadores',
  mkt_feat_reveal_desc: 'Coroná cada desafío con una lluvia de confeti cuando termina la fiesta.',
  mkt_feat_qr_title: 'Entran con un QR',
  mkt_feat_qr_desc: 'Los invitados escanean y ya están. Nada que descargar, funciona en cualquier teléfono.',
  mkt_feat_branding_title: 'Hacela tuya',
  mkt_feat_branding_desc: 'Sumá tu propio póster y fondo para que se sienta como tu evento.',
  mkt_feat_keep_title: 'Guardá cada foto',
  mkt_feat_keep_desc: 'Descargá toda la galería después de la fiesta. Almacenamiento opcional por 1 año.',
  mkt_shots_eyebrow: 'Velo en vivo',
  mkt_shots_title: 'Directo de una fiesta real.',
  mkt_shots_gallery: 'La galería en vivo',
  mkt_shots_voting: 'Votá los desafíos',
  mkt_shots_wall: 'El muro de ganadores',
  mkt_price_eyebrow: 'Precio simple',
  mkt_price_title: 'Pagás una vez por evento. Sin suscripción.',
  mkt_price_upto: 'Hasta {count} invitados',
  mkt_price_incl1: 'Cada invitado entra gratis, sin instalar apps',
  mkt_price_incl2: 'Galería en vivo + desafíos de fotos',
  mkt_price_incl3: 'Revelación de ganadores + fotos descargables',
  mkt_price_note: 'Sin anuncios. Nunca vendemos tus fotos. No pagás nada hasta que publiques tu evento.',
  mkt_price_cta: 'Creá tu evento',
  mkt_final_title: '¿Listo para encender tu fiesta?',
  mkt_final_sub: 'Armá tu evento en unos minutos y compartí un solo código QR con tus invitados.',
  mkt_final_cta: 'Creá tu evento',
  mkt_footer_join: 'Unirse a un evento',

  auth_login: 'Iniciar sesión',
  auth_createAccount: 'Crear cuenta de {type}',
  auth_host: 'anfitrión',
  auth_participant: 'participante',
  auth_emailOrUsername: 'Correo o usuario',
  auth_email: 'Correo',
  auth_username: 'Usuario',
  auth_password: 'Contraseña',
  auth_passwordHint: 'Mínimo {min} caracteres.',
  auth_usernameHint: 'Usuario: solo letras, números y . _ - — sin espacios, {min}–{max} caracteres.',
  auth_emailInvalid: 'Ingresá un correo válido.',
  auth_logInBtn: 'INICIAR SESIÓN',
  auth_signUp: 'REGISTRARSE',
  auth_needAccount: '¿No tenés cuenta? Registrate',
  auth_haveAccount: '¿Ya tenés cuenta? Iniciá sesión',
  auth_genericError: 'Algo salió mal',
  auth_forgotPassword: '¿Olvidaste tu contraseña?',
  forgot_title: 'Recuperar contraseña',
  forgot_subtitle: 'Ingresá el email de tu cuenta y te enviaremos un enlace para restablecer tu contraseña.',
  forgot_send: 'ENVIAR ENLACE',
  forgot_sent: 'Si existe una cuenta con ese email, el enlace ya está en camino. Revisá tu bandeja (y spam).',
  forgot_backToLogin: 'Volver al inicio de sesión',
  reset_title: 'Restablecer contraseña',
  reset_subtitle: 'Elegí una nueva contraseña para tu cuenta.',
  reset_newPassword: 'Nueva contraseña',
  reset_confirmPassword: 'Confirmar nueva contraseña',
  reset_submit: 'GUARDAR CONTRASEÑA',
  reset_mismatch: 'Las contraseñas no coinciden.',
  reset_done: 'Contraseña actualizada. Te llevamos al inicio de sesión…',
  reset_noToken: 'Este enlace de restablecimiento es inválido o está incompleto. Solicitá uno nuevo.',

  join_subtitle: 'Sacá fotos con tu cámara → votá a los ganadores. Sin instalar nada.',
  join_pinPlaceholder: 'PIN de acceso (si se requiere)',
  join_consent: 'Acepto que mis fotos aparezcan en la galería compartida y como candidatas en los desafíos.',
  join_joinAsGuest: 'UNIRSE COMO INVITADO Y AGREGAR FOTOS',
  join_joinAndAdd: 'UNIRSE Y AGREGAR FOTOS',
  join_joining: 'UNIÉNDOSE…',
  join_joiningAs: 'Te unís como {name}',
  join_notYou: '¿no sos vos?',
  join_optionalAccount: '+ Iniciá sesión / registrate para recibir resultados por correo (opcional)',
  join_couldNotJoin: 'No se pudo unir',

  uploader_addPhotos: 'Agregar fotos',
  uploader_left: '{n} RESTANTES',
  uploader_open: 'ABRIR CÁMARA / ELEGIR FOTOS',
  uploader_none: 'SIN SUBIDAS DISPONIBLES',
  uploader_notStarted: 'La fiesta todavía no empezó',
  uploader_opensAt: 'Vas a poder subir fotos el {time}',
  uploader_capReached: 'Límite de subidas alcanzado',
  uploader_failed: 'Error al subir',

  gallery_live: 'Galería en vivo',
  gallery_empty: 'Todavía no hay fotos — sé el primero.',
  gallery_locked: 'Las fotos se desbloquean cuando el anfitrión las revela.',
  gallery_loadMore: 'CARGAR MÁS',
  share_photo: 'Compartir foto',
  share_copied: 'Texto copiado al portapapeles',
  share_failed: 'No se pudo compartir — inténtalo de nuevo',
  share_legend: '¡Anima tus eventos con <a>Fiesta Challenges</a>!',
  share_invite: 'Sumate a {name} en Fiesta! Sacá fotos de la fiesta y votá los desafíos:',
  hostEvent_shareInvite: 'COMPARTIR INVITACIÓN',
  join_inviteFriends: 'Invitar amigos',

  polls_title: 'Desafíos',
  polls_open: 'ABIERTO',
  polls_voted: 'VOTADO ✓',
  polls_closed: 'CERRADO',
  polls_vote: 'VOTAR',
  polls_voting: 'VOTANDO…',
  polls_yourVote: 'tu voto',
  polls_photo: 'Foto',
  polls_votesFinal: '{n} votos · final',
  polls_votesLive: '{n} votos · en vivo',
  polls_couldNotVote: 'No se pudo votar',
  polls_submitPhoto: 'Enviá tu foto',
  polls_submitHint: 'Participá en este desafío con tu propia foto:',
  polls_submitting: 'Enviando…',
  polls_noSubmissions: 'Todavía no hay envíos — ¡sé el primero!',
  polls_closesIn: 'La votación cierra en',
  polls_votingClosed: 'Votación cerrada — la fiesta terminó',

  results_title: 'RESULTADOS',
  results_loginPrompt: 'Iniciá sesión para ver los resultados de este evento.',
  results_loggingIn: 'INICIANDO SESIÓN…',
  results_noAccess: 'Esa cuenta no tiene acceso a estos resultados.',
  results_expired: 'Las fotos y los resultados de este evento expiraron y ya no están disponibles.',
  results_noPollsClosed: 'Todavía no se cerró ningún desafío.',
  results_gallery: 'El muro',
  results_openPhoto: 'Ver foto',
  results_votes: '{n} votos',
  results_winner: 'Ganador',
  results_runnersUp: 'Finalistas',
  results_noVotesYet: 'Sin votos todavía',
  results_couldNotLoad: 'No se pudieron cargar los resultados',
  results_opening: 'Abriendo resultados…',
  results_openAtLink: 'Abrí el evento para ver los resultados',

  host_title: 'Consola de anfitrión',
  host_signedInAs: 'Sesión iniciada como {name}',
  host_loginPrompt: 'Iniciá sesión o creá una cuenta de anfitrión para administrar eventos.',
  host_participantWarning: 'Iniciaste sesión como participante ({name}). Las acciones de anfitrión requieren una cuenta de anfitrión.',
  host_createEvent: '+ CREAR EVENTO',
  host_myEvents: 'Mis eventos',
  host_noEvents: 'Todavía no hay eventos.',

  create_title: 'Crear evento',
  create_name: 'Nombre del evento',
  create_starts: 'Comienza',
  create_ends: 'Termina',
  create_capacity: 'Capacidad (invitados)',
  create_guestsUpTo: 'Hasta {count} invitados',
  create_revealMode: 'Modo de revelado',
  create_revealLive: 'En vivo (las fotos aparecen durante la fiesta)',
  create_revealAfter: 'Revelar después',
  create_submit: 'CREAR Y PUBLICAR',
  create_creating: 'CREANDO…',
  create_couldNotCreate: 'No se pudo crear el evento',

  hostEvent_backToEvents: '← Mis eventos',
  hostEvent_editName: 'Editar título',
  hostEvent_editDate: 'Editar fecha',
  hostEvent_save: 'Guardar',
  hostEvent_cancel: 'Cancelar',
  hostEvent_posterPosition: 'Reposicionar',
  hostEvent_draftNote: 'Este evento es un borrador — publicalo para compartir.',
  hostEvent_publish: 'PUBLICAR (prueba)',
  hostEvent_publishFailed: 'Error al publicar (¿está TEST_MODE activo?)',
  hostEvent_scanToJoin: '¡Escaneá para unirte y empezá a jugar los desafíos!',
  hostEvent_copyLink: 'COPIAR ENLACE',
  hostEvent_copied: 'COPIADO ✓',
  hostEvent_viewResults: 'VER PÁGINA DE RESULTADOS →',
  hostEvent_liveResults: 'Resultados en vivo',
  hostEvent_newPoll: 'Nuevo desafío (las candidatas se cargan al abrir)',
  hostEvent_pollTitlePlaceholder: 'Título del desafío',
  hostEvent_votePhotos: 'Votar fotos',
  hostEvent_votePeople: 'Votar personas',
  hostEvent_voteSubmissions: 'Envío de fotos (los invitados suben)',
  hostEvent_addPoll: 'AGREGAR DESAFÍO',
  hostEvent_open: 'Abrir',
  hostEvent_close: 'Cerrar',
  hostEvent_candidates: '{n} candidatas',
  hostEvent_couldNotLoad: 'No se pudo cargar el evento',
  hostEvent_couldNotCreatePoll: 'No se pudo crear el desafío',

  admin_title: 'Consola de administrador',
  admin_loginPrompt: 'Iniciá sesión con una cuenta de superadministrador.',
  admin_notAdmin: 'Esta cuenta no es administradora.',
  admin_events: 'Eventos',
  admin_published: 'Publicados',
  admin_participants: 'Participantes',
  admin_polls: 'Desafíos',
  admin_votes: 'Votos',
  admin_photos: 'Fotos',
  admin_revenue: 'Ingresos',
  admin_colEvent: 'Evento',
  admin_colHost: 'Anfitrión',
  admin_colStatus: 'Estado',
  admin_colFee: 'Pago recibido',
  admin_couldNotLoad: 'No se pudo cargar el panel',
  admin_tab_overview: 'Resumen',
  admin_tab_events: 'Eventos',
  admin_tab_polls: 'Desafíos',
  admin_tab_users: 'Usuarios',
  admin_colTitle: 'Título',
  admin_colVisibility: 'Conteo',
  admin_colCandidates: 'Candidatas',
  admin_colRole: 'Rol',
  admin_colType: 'Tipo',
  admin_colEmail: 'Correo',
  admin_colHosted: 'Organizados',
  admin_colJoined: 'Unido',
  admin_colVotesCast: 'Votos emitidos',
  admin_colCreated: 'Creado',
  admin_delete: 'Eliminar',
  admin_deleteConfirm: '¿Eliminar «{name}» y todos sus datos? No se puede deshacer.',
  admin_deleting: 'Eliminando…',
  admin_detail_participants: 'Participantes',
  admin_detail_payments: 'Pagos',
  admin_detail_hosted: 'Eventos organizados',
  admin_detail_memberships: 'Eventos en los que se unió',
  admin_anonymous: 'Anónimo',
  admin_winner: 'ganador',
  admin_when: 'Cuándo',
  admin_joinCode: 'Código',
  admin_none: 'Ninguno',
  admin_tab_suggestions: 'Desafíos sugeridos',
  admin_tab_emails: 'Correos',
  admin_detail_emails: 'Correos',
  admin_colSource: 'Origen',
  admin_colConsent: 'Aceptó',
  admin_colCollected: 'Recolectado',
  admin_exportCsv: 'Descargar CSV',
  admin_key: 'Clave',
  admin_source: 'Origen',
  admin_order: 'Orden',
  admin_active: 'Activo',
  admin_add: 'Agregar',
  admin_save: 'Guardar',
  admin_edit: 'Editar',
  admin_cancel: 'Cancelar',
  admin_newSuggestion: 'Nuevo desafío sugerido',
  admin_yes: 'Sí',
  admin_no: 'No',
  admin_tab_coupons: 'Cupones',
  admin_newCoupon: 'Nuevo cupón',
  admin_couponCode: 'Código',
  admin_couponFree: 'Gratis',
  admin_couponPercent: '% de descuento',
  admin_couponPercentOff: '% desc.',
  admin_couponMaxRedemptions: 'Máx. usos (vacío = ∞)',
  admin_couponExpires: 'Vence (vacío = nunca)',
  admin_couponRedeemed: 'usados',

  hostEvent_poster: 'Póster de la fiesta',
  hostEvent_addPoster: 'Agregar póster',
  hostEvent_changePoster: 'Cambiar póster',
  hostEvent_posterUploading: 'Subiendo…',
  hostEvent_background: 'Fondo personalizado',
  hostEvent_addBackground: 'Agregar fondo',
  hostEvent_changeBackground: 'Cambiar fondo',
  hostEvent_posterHint: 'Funciona mejor en vertical — unos 1080×1350 px (4:5). Mantené el sujeto centrado; los bordes pueden recortarse. JPG o PNG, hasta 12 MB.',
  hostEvent_backgroundHint: 'Fondo de pantalla completa del teléfono — usá una imagen vertical alta, unos 1080×1920 px (9:16). Mantené lo importante centrado; queda detrás de una capa oscura. JPG o PNG, hasta 12 MB.',
  hostEvent_saveDone: 'Guardar y listo',
  hostEvent_saved: 'Guardado ✓',
  hostEvent_photos: 'Fotos',
  hostEvent_photosHint: 'Todas las fotos del evento, incluidas las de los desafíos. Eliminá cualquier contenido inapropiado — se quita para todos, también de la pantalla, y no se puede deshacer.',
  hostEvent_photosEmpty: 'Todavía no hay fotos.',
  hostEvent_deletePhoto: 'Eliminar foto',
  hostEvent_deletePhotoConfirm: '¿Eliminar esta foto de forma permanente? No se puede deshacer.',
  hostEvent_deleteChallengePhotoConfirm: '¿Eliminar esta foto de forma permanente? También se retira del desafío "{c}" y se descartan los votos que recibió. No se puede deshacer.',
  hostEvent_deleteAllPhotos: 'Eliminar todas las fotos',
  hostEvent_deleteAllPhotosConfirm: '¿Eliminar de forma permanente las {n} fotos? No se puede deshacer.',
  hostEvent_previewInvitation: 'Vista previa de la invitación',
  hostEvent_voting: 'Votación',
  hostEvent_votingEnds: 'La votación termina',
  hostEvent_extend1h: 'Extender +1 hora',
  hostEvent_closeVotingNow: 'Cerrar votación ahora',
  invite_print: 'Imprimir / Guardar como PDF',
  invite_youreInvited: 'Estás invitado',
  hostEvent_suggestionsHint: 'Elegí un desafío sugerido o escribí el tuyo',
  hostEvent_suggestionSelect: '— Elegí un desafío sugerido —',

  join_emailOptional: 'Correo (opcional) — para resultados y novedades',
  join_marketingOptIn: 'Quiero recibir novedades del evento por correo',

  photo_takePhoto: 'Sacar foto',
  photo_chooseLibrary: 'Galería',

  nav_back: 'Volver',

  consent_title: 'Una última cosa',
  consent_agreeJoin: 'Aceptar y entrar',
  consent_cancel: 'Cancelar',

  gallery_loadError: 'No se pudieron cargar las fotos — se cortó la conexión.',
  gallery_errorEnded: 'Esta fiesta terminó — ya no se pueden agregar fotos.',
  gallery_errorNotMember: 'Volvé a unirte a la fiesta para ver las fotos.',
  gallery_errorGone: 'Esta fiesta ya no está disponible.',
  gallery_retry: 'Reintentar',

  ticker_newPhoto: '📸 ¡Nueva foto!',
  ticker_newVote: '🔥 ¡Alguien votó!',
  ticker_newPhotoIn: '📸 ¡Nueva foto en {c}!',
  ticker_newVoteIn: '🔥 ¡Nuevo voto en {c}!',
  wall_general: 'Galería',
  wall_winnerOf: 'Ganador de',
  wall_timeLeft: 'Tiempo restante',
  wall_votingEndsIn: 'La votación termina en:',
  wall_votingClosed: 'Votación cerrada',
  wall_partyOverTitle: '🏆 Los ganadores',
  wall_partyOver: '🏆 ¡Se terminó — estos son los ganadores!',
  wall_wrapTitle: '🎉 ¡Se terminó la fiesta!',
  wall_wrapBody: 'Gracias por celebrar juntos. La galería queda abierta: llevate tus fotos.',

  wall_join: 'Sumate a la fiesta en',
  wall_empty: 'Esperando la primera foto…',
  wall_photos: 'fotos',
  wall_unavailable: 'El muro en vivo de este evento no está disponible para mostrar en público.',
  hostEvent_openWall: '📺 ABRIR MURO EN VIVO (PROYECTOR)',
  hostEvent_wallHint: 'Un muro de fotos en vivo a pantalla completa para proyectar en un TV o proyector — sin iniciar sesión. Funciona durante y después de la fiesta.',
  hostEvent_copyWallLink: 'Copiar enlace del muro',

  footer_privacy: 'Política de privacidad',
  footer_terms: 'Términos del servicio',
  footer_deleteAccount: 'Eliminar cuenta',
  legal_lastUpdated: 'Última actualización',
  legal_placeholder: 'Esta es una plantilla inicial — hacela revisar por un abogado antes del lanzamiento.',

  // payment / publish
  pay_title: 'Publica tu evento',
  pay_eventFee: 'Tarifa del evento',
  pay_storageAddon: '+1 año de almacenamiento de fotos',
  pay_total: 'Total',
  pay_promoLabel: 'Código promocional',
  pay_promoApply: 'Aplicar',
  pay_promoApplied: 'Código aplicado',
  pay_promoFree: '¡Evento gratis!',
  pay_promoInvalid: 'Ese código promocional no es válido',
  pay_payAndPublish: 'Pagar {amount} y publicar',
  pay_publishFree: 'Publicar gratis',
  pay_publishTest: 'Publicar (modo prueba — sin cargo)',
  pay_notConfigured: 'Los pagos aún no están configurados. Inténtalo más tarde.',
  pay_processing: 'Procesando…',
  pay_backToEdit: '← Volver a editar el evento',

  // published landing
  published_checking_title: 'Confirmando tu pago…',
  published_checking_subtitle:
    'Un momento — esto suele tardar solo unos segundos. Te mostraremos el código de acceso en cuanto se confirme.',
  published_pending_title: 'Casi listo — finalizando tu evento',
  published_pending_subtitle:
    'Esto está tardando un poco más de lo habitual. Tu evento se publicará automáticamente en cuanto se confirme el pago. Puedes volver a comprobar o ir a tu panel — también se actualizará allí.',
  published_checkAgain: 'Comprobar de nuevo',
  published_title: '¡Ya estás en vivo! 🎉',
  published_subtitle: 'Tu evento está publicado. Comparte el código con tus invitados.',
  published_joinCode: 'Código de acceso',
  published_manage: 'Gestionar evento',

  err_generic: 'Algo salió mal. Probá de nuevo.',
  err_EVENT_NOT_JOINABLE: 'No se encontró el evento o no está abierto.',
  err_EVENT_NOT_FOUND: 'Evento no encontrado.',
  err_EVENT_ENDED: 'Este evento terminó.',
  err_EVENT_NOT_STARTED: 'La fiesta todavía no empezó — vas a poder subir fotos a partir del horario de inicio.',
  err_EVENT_EXPIRED: 'Este evento expiró.',
  err_NOT_A_MEMBER: 'Primero unite al evento.',
  err_NO_ACCESS: 'No tenés acceso a estos resultados.',
  err_ALREADY_VOTED: 'Ya votaste en este desafío.',
  err_POLL_CLOSED: 'Este desafío está cerrado.',
  err_POLL_NOT_OPEN: 'Este desafío todavía no está abierto.',
  err_POLL_NOT_FOUND: 'Desafío no encontrado.',
  err_BAD_CANDIDATE: 'Elegí una opción válida.',
  err_UPLOAD_CAP_REACHED: 'Alcanzaste el límite de subidas para este evento.',
  err_BAD_PIN: 'PIN de acceso incorrecto.',
  err_AGE_ACK_REQUIRED: 'Tenés que confirmar que sos mayor de 18 para unirte.',
  err_ACCOUNT_EXISTS: 'Ese correo o usuario ya está en uso.',
  err_EMAIL_EXISTS: 'Ese correo ya está registrado. Probá iniciar sesión.',
  err_USERNAME_EXISTS: 'Ese usuario ya está en uso. Elegí otro.',
  err_INVALID_CREDENTIALS: 'Correo/usuario o contraseña inválidos.',
  err_PASSWORD_BREACHED: 'Esta contraseña apareció en una filtración. Elegí otra.',
  err_NOT_A_HOST: 'Solo las cuentas de anfitrión pueden hacer eso.',
  err_NOT_HOST: 'Solo el anfitrión puede hacer eso.',
  err_NOT_PAID: 'Primero pagá el evento.',
  err_ALREADY_PAID: 'Este evento ya está pago.',
  err_ALREADY_EXTENDED: 'Este evento ya tiene almacenamiento de 1 año.',
  err_TEST_DISABLED: 'La publicación de prueba está deshabilitada.',
  err_NOT_ADMIN: 'Se requiere acceso de administrador.',
  err_RATE_LIMITED: 'Demasiados intentos. Esperá un momento.',
  err_VALIDATION_ERROR: 'Revisá el formulario e intentá de nuevo.',
  err_UNAUTHORIZED: 'Iniciá sesión de nuevo.',
  err_COUPON_NOT_FOUND: 'Ese código promocional no es válido',
  err_COUPON_INACTIVE: 'Ese código promocional ya no está activo',
  err_COUPON_EXPIRED: 'Ese código promocional ha expirado',
  err_COUPON_EXHAUSTED: 'Ese código promocional ya se ha canjeado por completo',
  err_COUPON_EXISTS: 'Ya existe un cupón con ese código',

  // eliminación de cuenta (consola del anfitrión)
  account_dangerZone: 'Zona de riesgo',
  account_delete: 'Eliminar mi cuenta',
  account_deleteConfirm:
    'Esto elimina tu cuenta de forma permanente. Los eventos que ya pagaste siguen activos hasta que venza su almacenamiento normal. Ingresá tu contraseña para confirmar.',
  account_passwordPlaceholder: 'Tu contraseña',
  account_deleteCta: 'Eliminar de forma permanente',
  account_deleteCancel: 'Cancelar',
  account_deleting: 'Eliminando…',
  account_deleteError: 'No se pudo eliminar tu cuenta. Revisá tu contraseña e intentá de nuevo.',

  // baja de marketing / borrado de datos
  unsub_title: 'Correos de marketing',
  unsub_intro: 'Gestioná los correos de marketing asociados a tu dirección de correo.',
  unsub_unsubscribe: 'Darme de baja de los correos de marketing',
  unsub_unsubscribed: 'Listo — ya no vas a recibir más correos de marketing nuestros.',
  unsub_forget: 'Eliminar mis datos',
  unsub_forgetHint: 'Eliminá tu correo de nuestra lista de marketing de forma permanente.',
  unsub_forgotten: 'Listo — tu correo fue eliminado de nuestra lista de marketing.',
  unsub_missingToken: 'Este enlace no es válido o ha expirado.',
  unsub_error: 'Algo salió mal. Intentá de nuevo.',
  unsub_working: 'Procesando…',

  // public account-deletion instructions page (/delete-account)
  del_title: 'Eliminar tu cuenta',
  del_intro:
    'Podés eliminar tu cuenta de Fiesta de forma permanente en cualquier momento. La eliminación es inmediata y no se puede deshacer.',
  del_whatTitle: 'Qué se elimina',
  del_what1: 'Tu cuenta y tu perfil: correo, usuario y acceso.',
  del_what2: 'Las fotos que subiste y cualquier evento en borrador sin publicar se borran de forma permanente del almacenamiento.',
  del_what3:
    'Los eventos que ya pagaste siguen activos hasta su vencimiento normal de almacenamiento y luego se eliminan automáticamente.',
  del_howTitle: 'Cómo eliminar tu cuenta',
  del_step1: 'Iniciá sesión en tu cuenta.',
  del_step2: 'Abrí la consola de anfitrión y buscá «Eliminar mi cuenta» en la Zona de peligro.',
  del_step3: 'Ingresá tu contraseña para confirmar. Tu cuenta se elimina de inmediato.',
  del_cta: 'Iniciar sesión para eliminar',
  del_noLoginTitle: '¿No podés iniciar sesión?',
  del_noLogin: 'Si ya no podés acceder a tu cuenta, escribinos y la eliminamos por vos:',
  del_privacyLink: 'Consultá nuestra Política de privacidad sobre cómo tratamos tus datos.',
};
